import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { withCookies } from "react-cookie";
import LeadGen from "../../../Common/Popups/LeadGen";

const VendorTestimonialLocked = (props) => {
  const { cookies } = props;
  const [isLeadGenPopUp, setLeadGenPopUp] = useState(false);
  const [isEntered, setIsEntered] = useState(false);
  const [vendorTestimonial, setVendorTestimonial] = useState({
    activeVideoPopUp: {
      isPopUpActive: false,
    },
    ...props,
  });
  const setPopUpFalse = (location) => {
    const tempObj = {
      ...vendorTestimonial,
      ...location,
      activeVideoPopUp: {
        isPopUpActive: false,
      },
    };
    setVendorTestimonial(tempObj);
    setIsEntered(false);
  };

  const postLeadRegPopUp = () => {
    setVendorTestimonial({
      ...vendorTestimonial,
      activeVideoPopUp: {
        isPopUpActive: true,
      },
      toLocation: props.pathname,
    });
  };

  const showLeadGenPopUp = (leadGenFlag) => {
    const isVisitor = !!props.vendorProfile.visitor;
    if (!isVisitor && leadGenFlag === false) {
      return false;
    }
    if (!isVisitor && leadGenFlag === true) {
      return true;
    }
    if (isVisitor) {
      return false;
    }
  };

  const showUpgradePopUp = (leadGenFlag) => {
    const isVisitor = !!props.vendorProfile.visitor;
    if (!isVisitor && leadGenFlag === false) {
      return true;
    }
    if (!isVisitor && leadGenFlag === true) {
      return false;
    }
    if (isVisitor) {
      return false;
    }
  };

  return (
    <>
      <li
        onClick={(e) => {
          e.preventDefault();
          if (showLeadGenPopUp(props.isLeadGenPopUp)) {
            setLeadGenPopUp(true);
          }
          if (showUpgradePopUp(props.isLeadGenPopUp)) {
            props.setUpgrade(true);
          }
        }}
      >
        <img src="/images/blur_img.png" alt="" />
        <div class="cls_content_locked">
          <span class="locked">currently locked</span>
        </div>
        {isLeadGenPopUp ? (
          <LeadGen
            {...props}
            setLeadGenPopUp={setLeadGenPopUp}
            postLeadRegPopUp={postLeadRegPopUp}
            pathname={props.pathname.replace("/testimonials", "")}
            linkedInUrl={props.linkedInUrl}
            isLocked
          />
        ) : null}
      </li>
    </>
  );
};

export default withRouter(withCookies(VendorTestimonialLocked));
